
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { User } from "@/types";
import { findUserByEmail, getUserPassword, storeUserSession } from "@/services/UserService";

interface UseLoginResult {
  login: (email: string, password: string) => Promise<void>;
  isLoading: boolean;
}

export const useLogin = (setUser: (user: User) => void): UseLoginResult => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const login = async (email: string, password: string) => {
    setIsLoading(true);
    try {
      // Simulando um delay de rede
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      const userFound = findUserByEmail(email);
      
      if (userFound) {
        const storedPassword = getUserPassword(userFound.id);
        
        if (storedPassword === password) {
          setUser(userFound);
          storeUserSession(userFound);
          toast.success("Login realizado com sucesso!");
          navigate("/dashboard");
        } else {
          toast.error("Senha incorreta");
        }
      } else {
        toast.error("Usuário não encontrado");
      }
    } catch (error) {
      toast.error("Erro ao fazer login");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return { login, isLoading };
};
